/**
 * Subscribe controller.
 *
 * This class controls Subscribe areas
 */

 // Use jQuery as $ within this file scope.
 const $ = jQuery;

/**
 * Class Subscribe
 */
module.exports = class Subscribe {

    /**
     * Store cached elements for use by the class
     *
     * @type {Object}
     */
    cached = {};

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.cached.$container     = $( '.footer-main-layout__item--email-signup' );
        this.cached.$formcontainer = this.cached.$container.find( '.email-signup' );
        this.cached.$form          = this.cached.$formcontainer.find( '.email-signup__form' );
        this.cached.$emailInput    = this.cached.$form.find( '.email-signup__form__input' );
        this.cached.$errorField    = this.cached.$form.find( '.email-signup__form__error' );
    }

    /**
     * Register event listeners
     */
    events() {
        this.cached.$form.on( 'submit', ( e ) => this.formSubmit( e ) );
    }

    /**
     * Ran on subscribe form submit
     *
     * @param {Object} e Form submit event object.
     */
    formSubmit( e ) {
        e.preventDefault();

        // Check disabled status so we dont send multiple times
        const disabled = this.cached.$form.attr( 'disabled' );
        if ( ! disabled ) {

            // Get email value, clear errors and disable the form
            const email = this.cached.$emailInput.val();
            this.cached.$errorField.empty();
            this.cached.$form.attr( 'disabled', true );
            this.cached.$formcontainer.addClass( 'disabled' );

            // Send the subscribe ajax call
            dp( 'subscribe', {
                partial: 'subscribe-success',
                data: true,
                tidy: true,
                args: {
                    email
                },

                /**
                 * On success replace the form content with the success message html
                 *
                 * @param {String} html Success html.
                 */
                success: ( html ) => {
                    this.cached.$formcontainer.html( html );
                    this.cached.$formcontainer.removeClass( 'disabled' );
                },

                /**
                 * On error remove disabled status and show error msg
                 *
                 * @param {Object} data Error data.
                 */
                error: ( data ) => {
                    this.cached.$form.removeAttr( 'disabled' );
                    this.cached.$formcontainer.removeClass( 'disabled' );
                    this.cached.$errorField.text( data.error );
                }
            });
        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
};



// WEBPACK FOOTER //
// ./assets/scripts/subscribe.js